import type { DonationsSearchValues } from "../types.ts";
import type { ExcelHeaderCellsName } from "@/features/operations/verifications/types.ts";

// ============================================
// Donations Search Defaults
// ============================================

export const donationsSearchValues: DonationsSearchValues = {
  toTime: "",
  fromTime: "",
  projectIds: [],
  projectAttributeId: "",
  projectClassificationId: "",
  stageName: "",
  smsSendingDateTimeFrom: "",
  smsSendingDateTimeTo: "",
  searchKey: "",
  isFirstStageVerified: "",
};

// ============================================
// Excel Header Mappings
// ============================================

export const donationsExcelHeaders: ExcelHeaderCellsName = {
  "اسم المشروع": "projectName",
  "اسم الفئة": "attributeName",
  "اسم المستخدم": "userName",
  "قيمة الطلب": "orderItemAmount",
  "معرف الطلب": "orderId",
  "تاريخ الإنشاء": "createdOn",
};
